// animatorProviderOptions — pure derivation of AnimatorPanel's provider/model
// dropdown from the bulk-animate preflight response (task 37 ASK 1). Mirrors
// the id->label map ImageAnimatorModal.jsx's own provider select already uses
// (PROVIDER_OPTIONS) so the same provider reads the same everywhere; an
// unrecognised id falls back to itself so a new backend provider still shows
// up instead of silently vanishing.
const PROVIDER_LABELS = {
  pixverse: "Pixverse",
  grok: "Grok",
  "gemini-fast": "Gemini Fast",
  gemini: "Gemini",
  kling: "Kling",
  ltx: "LTX",
  seedance: "Seedance",
  hailuo: "Hailuo",
};

export function providerLabel(id) {
  return PROVIDER_LABELS[id] || id;
}

// providers: preflight's top-level `providers` array (absent on an older
// server). defaultProvider: preflight.defaults.provider. When `providers` is
// missing/empty, falls back to just the default provider as the sole option
// so the dropdown still has something selectable.
export function deriveProviderOptions(providers, defaultProvider) {
  const ids =
    Array.isArray(providers) && providers.length ? providers : [defaultProvider].filter(Boolean);
  return ids.map((id) => ({ value: id, label: providerLabel(id) }));
}
